import { createEvent, createStore, sample } from 'effector'
import { fx } from '../../../libs'
import type { DayData } from './types'

export const loadRdcCheck = createEvent<{ dateFrom: string; dateTo: string }>()

export const getRdcCheck = fx<void, DayData[]>({
  method: 'GET',
  url: '/finance/rdc-check',
})

export const $rdcCheckData = createStore<DayData[]>([])
  .on(getRdcCheck.doneData, (_, r) => r.body)

export const $rdcCheckLoading = getRdcCheck.pending

sample({
  clock: loadRdcCheck,
  fn: ({ dateFrom, dateTo }) => ({
    url: `/finance/rdc-check?where=${JSON.stringify({ dateFrom, dateTo })}`,
  }),
  target: getRdcCheck,
})
